export default {
  name: 'app-header-noauth',
  created () {
  },
  data () {
    return {
    }
  },
  computed: {
    isStaging () {
      return process.env.NODE_ENV == 'staging' ? true:false
    }
  },
  methods: {
    goLogin: function () {
      this.$router.push({ path: '/login'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/app-header-noauth.js